module.exports = __webpack_public_path__ + "img/01.6e5e4b41.jpeg";